import '@webcomponents/webcomponentsjs/webcomponents-loader.js' // Needed for old browsers so we can display something to the user

if (!customElements.getName) {
  const constructorToName = new WeakMap()

  const origDefine = customElements.define
  customElements.define = function (name, ctor, options) {
    constructorToName.set(ctor, name)
    origDefine.call(this, name, ctor, options)
  }

  customElements.getName = function (ctor) {
    return constructorToName.get(ctor)
  }
}
